module.exports = __webpack_public_path__ + "static/media/FARM_M.b43e746a.png";